import { FC, useMemo } from 'react';
import type { RunStatus, RunTasksCount, TaskRunStatus } from '@/entities/jobs';
import { TaskCircleIcon } from './TaskCircleIcon';
import { CIRCLE_CLASS, TASK_CIRCLE_STYLES } from './utils';

type FallbackCirclesProps = {
  tasksCount: RunTasksCount;
  status: RunStatus;
};

// Кружки-заглушки, когда реальные данные задач недоступны
export const FallbackCircles: FC<FallbackCirclesProps> = ({ tasksCount, status }) => {
  const circles = useMemo(() => {
    const result: TaskRunStatus[] = [];
    for (let i = 0; i < tasksCount.success; i++) result.push('SUCCESS');
    for (let i = 0; i < tasksCount.failed; i++) result.push('FAILED');
    for (let i = 0; i < tasksCount.skipped; i++) result.push('SKIPPED');
    const remaining = tasksCount.total - tasksCount.success - tasksCount.failed - tasksCount.skipped;
    const remainingStatus: TaskRunStatus = status === 'RUNNING' ? 'RUNNING' : 'PENDING';
    for (let i = 0; i < remaining; i++) result.push(remainingStatus);
    return result;
  }, [tasksCount, status]);

  return (
    <>
      {circles.map((circleStatus, i) => {
        const styles = TASK_CIRCLE_STYLES[circleStatus] ?? TASK_CIRCLE_STYLES.PENDING;
        const isRunning = circleStatus === 'RUNNING';
        return (
          <div
            key={i}
            className={`${CIRCLE_CLASS} ${styles.bg} ${styles.border} ${styles.icon} ${isRunning ? 'animate-pulse' : ''}`}
          >
            <TaskCircleIcon status={circleStatus} />
          </div>
        );
      })}
    </>
  );
};
